module.exports = __webpack_public_path__ + "img/chest-open.13d60f83.png";